// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GdDB","footer":"styles_footer__iRQwk","passCodeTooltip":"styles_passCodeTooltip__3O5RR"};